import { TaskFileModel, UserModel } from "@/components/task-forms/models";
import { QueueRelationModel } from "@/components/task-forms/models";
import { getDefaultDedlineDate } from "../utils";
import UserTaskItem from "@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UserTaskItem";

/**
 * * Модель данных формы задачи
 */
export class TaskFormDataModel {
  /**ID папки с файлами */
  FolderId?: string;
  /**Название */
  Name: string = "";
  /**Описание */
  Description: string = "<div><br></div>";
  /**Статус */
  StatusId!: number;
  /**Тип задачи */
  TypeId!: string;
  /**Приортите */
  PriorityId!: number;
  /**Уровень сложности */
  DifficultyId!: string;
  /**Исполнители */
  Performers: UserModel[] = [];
  /**Наблюдатели */
  Observers: UserModel[] = [];
  /**Id исполнителей */
  PerformerIds: Array<number> = [];
  /**Id наблюдателей */
  ObserverIds: Array<number> = [];
  /**Оценка исполнителей */
  Estimated!: number;
  /**Дата дедлайна */
  DeadlineDate: Date = getDefaultDedlineDate();
  /**Список тегов */
  Tags: Array<number> = [];
  /**Подзадачи */
  SubtaskIds: Array<number> = [];
  /**Список файлов */
  Files: Array<TaskFileModel> = [];
  /**Очереди задачи */
  QueueToTaskRelationList: QueueRelationModel[];
  /**Автор */
  // OwnerId?: number;
  Owner?: UserTaskItem;
  constructor(obj?: Partial<TaskFormDataModel>) {
    Object.assign(this, obj);
  }
}
